module.exports = require("chained-function");


//////////////////
// WEBPACK FOOTER
// external "chained-function"
// module id = 4
// module chunks = 0